import { Box, Button, TextField } from '@mui/material';
import { isEmpty } from 'lodash';
import Dropdown from '../Dropdown';

const DropdownItemInput = ({
  value,
  newItem,
  setNewItem,
  onSubmit,
  isEdit,
  label,
  extraDropdownOptions
}) => {
  const handleTypeChange = (event) => {
    setNewItem({ ...newItem, type: event.target.value });
  };

  return (
    <>
      {!isEmpty(extraDropdownOptions) && (
        <Dropdown
          name="type"
          options={extraDropdownOptions}
          placeholder="Select course type"
          handleChange={handleTypeChange}
          defaultValue={newItem?.type}
          forCustomField={true}
        />
      )}
      <Box display="flex" gap={1} mb={1}>
        <TextField
          fullWidth
          size="small"
          value={value}
          onChange={(e) => setNewItem({ ...newItem, value: e.target.value })}
          placeholder={label}
        />
        <Button variant="contained" size="small" onClick={onSubmit}>
          {isEdit ? 'Update' : 'Create'}
        </Button>
      </Box>
    </>
  );
};

export default DropdownItemInput;
